import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import translationEn from "./locales/en/translation.json";
import translationAr from "./locales/ar/translation.json";

const resources = {
  en: { translation: translationEn },
  ar: { translation: translationAr },
};

i18n
  .use(LanguageDetector) // برای تشخیص زبان از مرورگر یا localStorage
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: "en",
    supportedLngs: ["en", "ar"], // فقط همین زبان‌ها رو بپذیر
    interpolation: { escapeValue: false },
    detection: {
      order: ["localStorage", "navigator"],
      lookupLocalStorage: "i18nextLng",
    },
  });

export default i18n;
